import { useMetricRamQuery } from "@/common/api/metric/use-metric-ram.query";
import { MetricCard } from "@/components/dashboard/cards/metric-card";
import { UserIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function UserMetric() {
  const { t } = useTranslation(["ram", "common"]);
  const { data, isLoading } = useMetricRamQuery();

  return <MetricCard icon={UserIcon} label={t("common:Users")} value={data?.userCount ?? 0} loading={isLoading} />;
}
